import { ref, computed } from 'vue'
import { defineStore } from 'pinia'

import type { Nullable, User } from '@/types'
import { Role } from '@/types'
import container from '@/di/di.container'
import Token from '@/di/di.token'
import type { TokensManager } from '@/core/auth/TokensManager'
import type AuthService from '@/services/AuthService'

const user = ref<Nullable<User>>(null)

export const useAuthStore = defineStore('auth', () => {
  const tokens = container.get<TokensManager>(Token.TOKENS_MANAGER)
  const service = container.get<AuthService>(Token.AUTH_SERVICE)
  const isAdmin = computed(() => user.value?.role === Role.ADMIN)

  function authenticate() {
    if (user.value === null) {
      fetch()
    }
    return tokens.token !== undefined && tokens.refreshToken !== undefined
  }

  async function fetch() {
    user.value = await service.get()
    return user.value
  }

  return { user, authenticate, fetch, isAdmin }
})

export default useAuthStore
